import { MappingValue } from 'src/entities/import';

export const mappingValues = (value: MappingValue): string[] => {
  if (Array.isArray(value)) return value.filter(Boolean);
  return value ? [value] : [];
};

export const singleMappingValue = (value: MappingValue): string | null => {
  if (Array.isArray(value)) return value.find(Boolean) || null;
  return value || null;
};

export const invalidSingleValueMappings = (
  keys: string[],
  mappings: Record<string, MappingValue>,
  allowedValues: string[]
): string[] => keys.filter((key) => {
  const value = singleMappingValue(mappings[key]);
  return !!value && !allowedValues.includes(value);
});
